export type CommandType =
  | 'Lock'
  | 'Reboot'
  | 'ResetPassword'
  | 'StartLostMode'
  | 'StopLostMode'
  | 'Wipe'
  | 'Sync'
  | 'ClearAppData';

export const CommandTypeMap: Record<number, CommandType> = {
  0: 'Lock',
  1: 'Reboot',
  2: 'ResetPassword',
  3: 'StartLostMode',
  4: 'StopLostMode',
  5: 'Wipe',
  6: 'Sync',
  7: 'ClearAppData',
};

export const CommandTypeLabels: Record<CommandType, string> = {
  Lock: 'Bloquear',
  Reboot: 'Reiniciar',
  ResetPassword: 'Resetear PIN',
  StartLostMode: 'Modo perdido',
  StopLostMode: 'Salir de perdido',
  Wipe: 'Borrado total',
  Sync: 'Sincronizar',
  ClearAppData: 'Limpiar app',
};

export type CommandStatus = 'Pending' | 'Sent' | 'Completed' | 'Failed' | 'Cancelled' | 'Expired';

export const CommandStatusMap: Record<number, CommandStatus> = {
  0: 'Pending',
  1: 'Sent',
  2: 'Completed',
  3: 'Failed',
  4: 'Cancelled',
  5: 'Expired',
};

export const CommandStatusLabels: Record<CommandStatus, string> = {
  Pending: 'Pendiente',
  Sent: 'Enviado',
  Completed: 'Completado',
  Failed: 'Fallo',
  Cancelled: 'Cancelado',
  Expired: 'Expirado',
};

export const CommandStatusColors: Record<CommandStatus, string> = {
  Pending: 'default',
  Sent: 'processing',
  Completed: 'success',
  Failed: 'error',
  Cancelled: 'warning',
  Expired: 'warning',
};

export interface CommandDto {
  id: number;
  deviceId: number;
  deviceLabel: string;
  commandType: number;
  status: number;
  requestedByUserId: number;
  requestedByName: string;
  requestedAt: string;
  executedAt?: string | null;
  completedAt?: string | null;
  googleOperationId?: string | null;
  responseMessage?: string | null;
  errorMessage?: string | null;
  parametersJson?: string | null;
}

export interface CreateCommandRequest {
  deviceId: number;
  commandType: number;
  parametersJson?: string;
}

export interface CommandListRequest {
  page?: number;
  pageSize?: number;
  deviceId?: number;
  status?: number;
  commandType?: number;
}
